import * as actionType from "../constants";
const initialState = { loginData: "" };
export const loginDetails = (state = initialState, action) => {
  
  switch (action.type) {
    case actionType.LOGIN_DETAILS:
      return { ...state, loginData: action.payload };
      break;
    default:
      return state;
  }
};
